import { createApp } from 'vue'

// Load Delego SDK dynamically (URL is environment-specific).
// Validate against known domain pattern before injecting to guard against
// misconfigured or compromised environment variables.
const delegoUrl = APP_ENV.VITE_APP_DELEGO_URL
if (delegoUrl && /^https:\/\/[a-z0-9-]+\.delego-cloud\.com(\/|$)/i.test(delegoUrl)) {
  const delegoScript = document.createElement('script')
  delegoScript.src = `${delegoUrl}/sdk/sdk.bundle.js`
  delegoScript.crossOrigin = 'anonymous'
  document.head.appendChild(delegoScript)
} else {
  // eslint-disable-next-line no-console
  console.error('[Delego] Skipping SDK load — missing or invalid VITE_APP_DELEGO_URL:', delegoUrl)
}

// Components and default styles
import { fusionComponents } from '@/plugins/components'
import '@fusion/saas-components-v3/styles'

// Active theme
import { fusionTheme } from '@/plugins/theme'

// I18n
import { i18n } from '@/plugins/i18n'

// Vuetify
import { vuetify } from '@/plugins/vuetify'
import 'vuetify/dist/vuetify.css'

// Maps
import { maps } from '@/plugins/maps'
import '@gmap-vue/v3/dist/style.css'

// Styles
import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/global.scss'

// Fusion Auth
import Auth0Plugin, { getAuthOptions } from '@/plugins/auth'
import { permissions } from '@/plugins/permissions'

// Google Tag Manager
import { getGtm } from '@/plugins/gtm'

import App from '@/App.vue'
import { getRouter } from '@/router'
import store from '@/store'
import ApiPlugin from '@/api/service'

// Any setup that requires Auth0 needs to happen after we await the router
const setup = async () => {
  const app = createApp(App)
  const router = await getRouter(app)
  app.use(router)
  app.use(Auth0Plugin, getAuthOptions(router))
  app.use(ApiPlugin)
  app.use(i18n)
  app.use(store)
  app.use(vuetify)
  app.use(maps)
  app.use(fusionComponents)
  app.use(fusionTheme)
  app.use(permissions)
  app.use(getGtm(router))
  app.mount('#app')
}

setup()
